module.exports = __webpack_public_path__ + "img/党徽.577feb28.png";